import React from "react";

import GeneralAccessManagement from "./GeneralAccess";
import RoleViewManagement from "./View";

// Import utilities
import { isAllowedToDo } from "permissions-hub";
import { ACCEPTED_PERMISSIONS } from "constants";
import { isReadOnly } from "validations";

const RoleManagement = ({ permissions }) => {
  
  // Is read-only ?
  const isReadOnlyy = isReadOnly(permissions);

  // Check read permission
  const isAllowedToRead = isAllowedToDo(
    ACCEPTED_PERMISSIONS["read"],
    permissions
  );

  // Check create permission for role management
  const isAllowedToCreate = isAllowedToDo(
    ACCEPTED_PERMISSIONS["create"],
    permissions
  );

  // Check update permission for role management
  const isAllowedToUpdate = isAllowedToDo(
    ACCEPTED_PERMISSIONS["update"],
    permissions
  );

  // Check delete permission for role management
  const isAllowedToDelete = isAllowedToDo(
    ACCEPTED_PERMISSIONS["delete"],
    permissions
  );

  // Pass RoleViewManagement as a prop if isGeneralAccess is true
  const ManagementComponent = isReadOnlyy ? (
    <RoleViewManagement />
  ) : (
    <GeneralAccessManagement
      isAllowedToRead={isAllowedToRead}
      isAllowedToCreate={isAllowedToCreate}
      isAllowedToUpdate={isAllowedToUpdate}
      isAllowedToDelete={isAllowedToDelete}
      RoleViewManagement={RoleViewManagement}
    />
  );

  return ManagementComponent;
};

export default RoleManagement;
